module.exports = __webpack_public_path__ + "static/media/32-7.f4733539.mp3";